package com.deange.nastychristmas.state

import com.deange.nastychristmas.firebase.Firestore
import com.deange.nastychristmas.firebase.add
import com.deange.nastychristmas.store.PersistentStorage
import com.deange.nastychristmas.store.preference
import com.deange.nastychristmas.workflow.AppState.ChangeGameSettings
import com.deange.nastychristmas.workflow.AppState.EndGame
import com.deange.nastychristmas.workflow.AppState.InitializingPlayers
import com.deange.nastychristmas.workflow.AppState.OpeningGift
import com.deange.nastychristmas.workflow.AppState.PickingPlayer
import com.deange.nastychristmas.workflow.AppState.StealingRound
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.launch
import nastychristmas.app.generated.resources.Res
import nastychristmas.app.generated.resources.bad_words
import org.jetbrains.compose.resources.getStringArray
import kotlin.properties.ReadWriteProperty
import kotlin.reflect.KProperty

class GameSaver(
  storage: PersistentStorage,
  private val firestore: Firestore,
  private val updaterScope: CoroutineScope,
) {
  private val preference = storage.preference<GameState?>("game-state", null)
  private var game: GameState? by preference

  fun onGameSaved(): Flow<GameState?> = preference.asFlow()

  fun game(): ReadWriteProperty<Any?, GameState?> {
    return object : ReadWriteProperty<Any?, GameState?> {
      override fun getValue(thisRef: Any?, property: KProperty<*>): GameState? {
        return game
      }

      override fun setValue(thisRef: Any?, property: KProperty<*>, value: GameState?) {
        game = value

        updaterScope.launch {
          saveGameState(value)
        }
      }
    }
  }

  fun restore(): GameState? {
    return runCatching { game }
      .onFailure { e ->
        e.printStackTrace()
        game = null
      }
      .getOrNull()
  }

  suspend fun generateGameCode(): String {
    val badWords = getStringArray(Res.array.bad_words).map { it.uppercase() }

    lateinit var code: String
    do {
      code = List(6) { GAME_CODE_CHARS.random() }.joinToString("")
    } while (badWords.any { it in code } || firestore.exists("game-state/$code"))

    return code
  }

  private suspend fun saveGameState(gameState: GameState?) {
    val gameCode = when (val appState = gameState?.appState) {
      is InitializingPlayers -> appState.gameCode
      is PickingPlayer -> appState.settings.gameCode
      is StealingRound -> appState.settings.gameCode
      is OpeningGift -> appState.settings.gameCode
      is EndGame -> appState.settings.gameCode
      is ChangeGameSettings -> appState.settings.gameCode
      null -> null
    }

    if (gameState != null && gameCode != null) {
      firestore.add("game-state/$gameCode/", gameState)
    }
  }

  private companion object {
    private val GAME_CODE_CHARS = ('A'..'Z')
  }
}
